import React from "react";
import styles from "./SocialMedia.module.scss";
import { WhatsappShareButton } from "react-share";
// import { useOtherDetails } from "../../logic/useOtherDetails";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

const SocialMedia = ({ partnersData }) => {
  // const partnersData = useOtherDetails();

  let whatsappUrl = partnersData?.socialLinks[4]?.link;
  return (
    <ul className={styles.socialmedia}>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/swprayer"
        >
          <FaFacebookF />
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href="https://twitter.com/swprayer">
          <FaTwitter />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/swprayer/"
        >
          <FaInstagram />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/channel/UCIFjeNtkyUCoxoPOxXkarTA"
        >
          <FaYoutube />
        </a>
      </li>
      <li>
        <WhatsappShareButton url={whatsappUrl} className={styles.WhatsappIcon}>
          <FaWhatsapp />
        </WhatsappShareButton>
      </li>
    </ul>
  );
};
export default SocialMedia;
